export const pl = {
  "app.title": "survivrr.io",
  "menu.online": "Online",
  "menu.offline": "Offline",
  "menu.play": "Graj",
  "menu.name": "Nazwa",
  "menu.ballColor": "Kolor kulki",
  "menu.nameColor": "Kolor nazwy",
  "menu.moreInfo": "Więcej informacji",
  "menu.moreInfoTitle": "Więcej informacji",
  "menu.moreInfoSubtitle": "Strony prawne, informacje o cookies i kontakt.",
  "menu.back": "Wstecz",
  "menu.privacySettings": "Ustawienia prywatności",
  "menu.cookiePolicy": "Polityka cookies",
  "menu.privacyPolicy": "Polityka prywatności",
  "menu.termsOfService": "Regulamin",
  "menu.emailButton": "Napisz e-mail",
  "menu.websiteButton": "Sprawdź moją stronę",
  "menu.contactEmailLabel": "E-mail kontaktowy:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Sprawdź moją stronę:",
  "menu.nameRequired": "Najpierw wpisz nazwę.",
  "moreInfo.privacySettings.intro1": "Możesz zarządzać wyborami prywatności na tej stronie przez komunikat zgody wyświetlany przez naszego dostawcę reklam, gdy jest dostępny.",
  "moreInfo.privacySettings.intro2": "Możesz też w dowolnym momencie kontrolować cookies i pamięć lokalną w ustawieniach przeglądarki.",
  "moreInfo.privacySettings.adsHeading": "Ustawienia reklam",
  "moreInfo.privacySettings.adsParagraph": "Niektóre reklamy mogą być dostarczane przez Google lub innych partnerów. Ustawienia reklam spersonalizowanych można też zmienić bezpośrednio w ustawieniach reklam Google.",
  "moreInfo.privacySettings.adsBullet1": "Otwórz ustawienia reklam Google na myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Wyczyść cookies lub dane strony, jeśli chcesz zresetować wybory zgód.",
  "moreInfo.privacySettings.adsBullet3": "Użyj ustawień prywatności przeglądarki, aby blokować lub ograniczać cookies.",
  "moreInfo.privacySettings.localHeading": "Ustawienia lokalne",
  "moreInfo.privacySettings.localParagraph": "Gra zapisuje podstawowe preferencje lokalne, takie jak nazwa gracza, kolory, ustawienie dźwięku i język, aby strona mogła je zapamiętać na Twoim urządzeniu.",
  "moreInfo.cookiePolicy.intro1": "Ta strona używa cookies i podobnych technologii przechowywania danych, aby uruchamiać grę, zapamiętywać ustawienia i obsługiwać reklamy.",
  "moreInfo.cookiePolicy.intro2": "Cookies mogą być też używane do pomiarów, zapobiegania oszustwom i personalizacji reklam zależnie od Twoich zgód oraz usług włączonych na stronie.",
  "moreInfo.cookiePolicy.typesHeading": "Rodzaje cookies i pamięci, których możemy używać",
  "moreInfo.cookiePolicy.typeBullet1": "Niezbędna pamięć potrzebna do działania strony.",
  "moreInfo.cookiePolicy.typeBullet2": "Pamięć preferencji używana do zapamiętania nazwy, kolorów, języka i ustawień dźwięku.",
  "moreInfo.cookiePolicy.typeBullet3": "Cookies reklamowe lub pomiarowe używane przez partnerów reklamowych, takich jak Google, gdy reklamy są włączone.",
  "moreInfo.cookiePolicy.manageHeading": "Jak zarządzać cookies",
  "moreInfo.cookiePolicy.manageParagraph": "Możesz zarządzać cookies przez komunikat zgody na stronie, gdy jest dostępny, albo przez ustawienia przeglądarki. Wyłączenie niektórych cookies może wpłynąć na funkcje strony lub wyświetlanie reklam.",
  "moreInfo.privacyPolicy.intro1": "Ta strona to gra przeglądarkowa prowadzona przez Michała Kierzkowskiego. Staramy się zbierać jak najmniej danych osobowych.",
  "moreInfo.privacyPolicy.intro2": "Do gry nie jest wymagane konto. Gra może zapisywać podstawowe preferencje lokalne na Twoim urządzeniu i przetwarzać dane rozgrywki potrzebne do meczów online.",
  "moreInfo.privacyPolicy.infoHeading": "Informacje, które możemy przetwarzać",
  "moreInfo.privacyPolicy.infoBullet1": "Wybrana nazwa gracza i ustawienia wyglądu.",
  "moreInfo.privacyPolicy.infoBullet2": "Podstawowe dane sesji wymagane do działania funkcji multiplayer.",
  "moreInfo.privacyPolicy.infoBullet3": "Dane urządzenia, przeglądarki lub reklam zbierane przez partnerów analitycznych lub reklamowych, jeśli te usługi są włączone.",
  "moreInfo.privacyPolicy.useHeading": "Jak używamy informacji",
  "moreInfo.privacyPolicy.useBullet1": "Do działania gry i pokoi online.",
  "moreInfo.privacyPolicy.useBullet2": "Do zapamiętywania ustawień na Twoim urządzeniu.",
  "moreInfo.privacyPolicy.useBullet3": "Do poprawy wydajności, bezpieczeństwa i stabilności.",
  "moreInfo.privacyPolicy.useBullet4": "Do wyświetlania reklam, gdy reklamy są włączone.",
  "moreInfo.privacyPolicy.contactHeading": "Kontakt",
  "moreInfo.privacyPolicy.contactParagraph1": "W sprawach prywatności napisz na: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Strona: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Korzystając z tej strony, zgadzasz się używać gry legalnie i uczciwie.",
  "moreInfo.terms.intro2": "Gra jest udostępniana w stanie takim, w jakim jest, i może zostać zmieniona, przerwana lub usunięta w dowolnym momencie.",
  "moreInfo.terms.rulesHeading": "Zasady",
  "moreInfo.terms.ruleBullet1": "Nie nadużywaj błędów, cheatów, automatyzacji ani exploitów.",
  "moreInfo.terms.ruleBullet2": "Nie próbuj szkodzić usłudze ani innym graczom.",
  "moreInfo.terms.ruleBullet3": "Nie używaj obraźliwych, nielegalnych ani wprowadzających w błąd nazw lub treści.",
  "moreInfo.terms.limitationHeading": "Ograniczenie odpowiedzialności",
  "moreInfo.terms.limitationParagraph": "Nie odpowiadamy za straty, przerwy lub szkody wynikające z korzystania ze strony w maksymalnym zakresie dozwolonym przez prawo.",
  "moreInfo.terms.changesHeading": "Zmiany",
  "moreInfo.terms.changesParagraph": "Te warunki mogą zostać zaktualizowane w przyszłości. Dalsze korzystanie ze strony po aktualizacji oznacza akceptację nowych warunków.",
  "status.offline": "Uruchamianie gry offline...",
  "status.connecting": "Łączenie z serwerem...",
  "queue.title": "Oczekiwanie na pokój",
  "queue.menu": "Wróć do menu głównego",
  "game.pressToMove": "Naciśnij gdziekolwiek, aby się poruszać",
  "game.touchToMove": "Dotknij gdziekolwiek, aby się poruszać",
  "game.leaderboard": "Ranking",
  "game.hp": "HP",
  "game.level": "Poziom",
  "game.xp": "XP",
  "game.respawning": "Odrodzenie...",
  "gameEnd.title": "Koniec gry",
  "gameEnd.winTitle": "Wygrana",
  "gameEnd.subtitle": "Mecz się zakończył. Odrodź się, aby rozpocząć kolejną rundę, albo wróć do menu.",
  "pause.title": "Menu gry",
  "pause.resume": "Kontynuuj",
  "pause.menu": "Wróć do menu głównego",
  "upgrade.title": "Wybierz ulepszenie",
  "upgrade.generic.title": "Ulepszenie",
  "upgrade.generic.description": "Ulepsz swój build.",
  "upgrade.newWeaponPrefix": "Nowa broń:",
  "upgrade.stat.maxHp.title": "Maks. HP",
  "upgrade.stat.maxHp.description": "Zwiększa maksymalne HP.",
  "upgrade.stat.speed.title": "Szybkość ruchu",
  "upgrade.stat.speed.description": "Zwiększa szybkość ruchu.",
  "upgrade.stat.generic.title": "Ulepszenie statystyk",
  "upgrade.stat.generic.description": "Ulepsz swoje statystyki.",
  "upgrade.weapon.projectileShot.title": "Strzał pociskiem",
  "upgrade.weapon.projectileShot.description": "Dodaje strzały pociskami do buildu.",
  "upgrade.weapon.orbitingBalls.title": "Kule orbitalne",
  "upgrade.weapon.orbitingBalls.description": "Dodaje kule orbitalne do buildu.",
  "upgrade.weapon.damageZone.title": "Strefa obrażeń",
  "upgrade.weapon.damageZone.description": "Dodaje strefę obrażeń wokół postaci.",
  "upgrade.weapon.generic.title": "Broń",
  "upgrade.weapon.generic.description": "Dodaj tę broń do buildu.",
  "upgrade.weaponUpgrade.frequency.title": "Częstotliwość",
  "upgrade.weaponUpgrade.frequency.description": "Atakuj częściej.",
  "upgrade.weaponUpgrade.range.title": "Zasięg",
  "upgrade.weaponUpgrade.range.description": "Zwiększa zasięg broni.",
  "upgrade.weaponUpgrade.projectileCount.title": "Liczba pocisków",
  "upgrade.weaponUpgrade.projectileCount.description": "Tworzy więcej pocisków.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Szybkość pocisków",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Sprawia, że pociski lecą szybciej.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Szybkość orbitalna",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Sprawia, że kule orbitalne obracają się szybciej.",
  "upgrade.weaponUpgrade.damage.title": "Obrażenia",
  "upgrade.weaponUpgrade.damage.description": "Zadaje więcej obrażeń.",
  "upgrade.weaponUpgrade.generic.title": "Ulepszenie broni",
  "upgrade.weaponUpgrade.generic.description": "Ulepsz tę broń.",
  "defeat.title": "Porażka",
  "defeat.subtitle": "Odrodź się albo wróć do menu",
  "defeat.respawn": "Odrodź",
  "defeat.menu": "Menu główne",
  "error.generic": "Coś poszło nie tak.",
} as const;
